<div class="container" [ngClass]="'background-' + type">
  <mat-icon>{{ type }}</mat-icon>
  <span class="message">{{ message }}</span>
</div>
